import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const LogoYaspa = ({ className }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        width={28}
        height={20}
        viewBox='0 0 28 20'
        fill='none'
    >
        <rect
            width='28'
            height='20'
            fill='#4E39A8'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M11.4732 7.83195H11.9669C12.0209 7.83195 12.0628 7.87592 12.0628 7.92789V11.0539C12.0628 11.1099 12.0169 11.1559 11.9609 11.1559H11.4732C11.4132 11.1559 11.3793 11.1159 11.3793 11.0539L11.3653 10.6122C11.1274 10.998 10.7337 11.2358 10.192 11.2358C9.2426 11.2358 8.591 10.4763 8.591 9.49291C8.591 8.50953 9.2426 7.75 10.192 7.75C10.7417 7.75 11.1354 7.99585 11.3653 8.38161L11.3793 7.93388C11.3793 7.87192 11.4112 7.83195 11.4732 7.83195ZM9.30256 9.49291C9.30256 10.1365 9.73629 10.5642 10.3339 10.5642V10.5662C10.9235 10.5662 11.3373 10.1465 11.3373 9.50091C11.3373 8.85531 10.9315 8.42158 10.3339 8.42158C9.73629 8.42158 9.30256 8.84931 9.30256 9.49291Z'
            fill='white'
        />
        <path
            d='M13.8817 9.12914L14.2814 9.29104L14.2854 9.29504C14.7112 9.46293 15.051 9.74276 15.051 10.2504C15.043 10.9 14.4873 11.2398 13.8497 11.2398C13.3061 11.2398 12.9123 10.988 12.6824 10.7102C12.6405 10.6622 12.6405 10.5942 12.6884 10.5263L12.8643 10.2824C12.9103 10.2145 12.9723 10.2205 13.0262 10.2684C13.2721 10.4783 13.5159 10.6142 13.8137 10.6142C14.1116 10.6142 14.3214 10.4923 14.3214 10.2285C14.3214 9.9986 14.1655 9.89067 13.8937 9.77474L13.4859 9.61284C13.0662 9.44295 12.7464 9.17112 12.7464 8.70341C12.7464 8.10578 13.2561 7.754 13.8457 7.754C14.2535 7.754 14.6332 7.9239 14.8911 8.2417C14.933 8.28967 14.925 8.34363 14.8851 8.38361L14.6752 8.63545C14.6212 8.69741 14.5753 8.68942 14.5133 8.63545C14.3014 8.43757 14.0996 8.34363 13.8817 8.34363C13.6239 8.34363 13.448 8.46556 13.448 8.69541C13.448 8.92527 13.6239 9.02721 13.8817 9.12914Z'
            fill='white'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M17.5074 7.75C16.9578 7.75 16.564 7.99385 16.3342 8.38161L16.3202 7.93388C16.3202 7.87192 16.2862 7.83195 16.2262 7.83195H15.7385C15.6826 7.83195 15.6366 7.87792 15.6366 7.93388V12.1912C15.6366 12.2432 15.6786 12.2872 15.7325 12.2872H16.2682C16.3242 12.2872 16.3701 12.2412 16.3701 12.1852V10.6622C16.608 11.022 16.9938 11.2378 17.5094 11.2378C18.4588 11.2378 19.1104 10.4843 19.1104 9.49491C19.1104 8.50553 18.4588 7.752 17.5094 7.752L17.5074 7.75ZM17.3655 10.5642C16.7759 10.5642 16.3621 10.1365 16.3621 9.49891C16.3621 8.86131 16.7759 8.41958 17.3655 8.41958C17.9552 8.41958 18.3969 8.85331 18.3969 9.49091C18.3969 10.1285 17.9631 10.5622 17.3655 10.5622V10.5642Z'
            fill='white'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M22.4084 7.83195H22.9041V7.82995C22.958 7.82995 23 7.87392 23 7.92589V11.0599C23 11.1139 22.956 11.1559 22.9041 11.1559H22.4084C22.3484 11.1559 22.3144 11.1159 22.3144 11.0539L22.3004 10.6122C22.0626 10.998 21.6688 11.2358 21.1272 11.2358C20.1778 11.2358 19.5262 10.4763 19.5262 9.49291C19.5262 8.50953 20.1778 7.75 21.1272 7.75C21.6768 7.75 22.0706 7.99585 22.3004 8.38161L22.3144 7.93388C22.3144 7.87192 22.3464 7.83195 22.4084 7.83195ZM20.2377 9.49291C20.2377 10.1365 20.6715 10.5642 21.2691 10.5642V10.5662C21.8587 10.5662 22.2725 10.1465 22.2725 9.50091C22.2725 8.85531 21.8667 8.42158 21.2691 8.42158C20.6715 8.42158 20.2377 8.84931 20.2377 9.49291Z'
            fill='white'
        />
        <path
            d='M7.88145 7.75801C7.51768 7.70204 7.20787 8.01185 7.26383 8.37562C7.29781 8.60348 7.4837 8.78737 7.71156 8.82334C8.07533 8.87931 8.38513 8.5695 8.32917 8.20573C8.29519 7.97787 8.10931 7.79399 7.88145 7.75801Z'
            fill='white'
        />
        <path
            d='M5.83073 7.83196C5.8727 7.83196 5.91268 7.85194 5.93866 7.88392L7.33379 9.58886C7.55565 9.86069 7.55565 10.2564 7.33379 10.5283L5.93866 12.2332C5.91268 12.2672 5.8727 12.2852 5.83073 12.2852H5.04722C5.00724 12.2852 4.98526 12.2392 5.01124 12.2072L6.76215 10.0786C6.77214 10.0666 6.77214 10.0506 6.76215 10.0386L5.01124 7.90991C4.98526 7.87793 5.00724 7.83196 5.04722 7.83196H5.83073Z'
            fill='white'
        />
    </SvgElement>
);
